import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {VisuallyHiddenTextProps} from './visually-hidden-text.types';
import styles from './visually-hidden-text.module.scss';

/**
 * Names a state that the design conveys with colour, an icon or a chart alone. `aria-label` cannot do this job
 * here: on a generic element such as the `<i>` an `<Icon>` renders, ARIA prohibits the name and browsers drop it.
 */
export function VisuallyHiddenText({val, id}: VisuallyHiddenTextProps): ReactElement {
  const attributes: Record<string, string> = id === undefined ? {} : {id};

  return <Text val={val} size={TextSize.SM} className={styles.visuallyHidden} attributes={attributes} />;
}
